import React, { useState, useEffect, useRef } from 'react';
import dataProvider from '../../lib/dataProvider';
import { apiPath } from '../../lib/isTest';
import { getGlobalData, isHauptadmin } from '../../lib/globalData';
import Ansi from "../../lib/ansi2react";
import { useTranslate } from 'react-admin';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const BwhTranslation = () => {
  const tr = useTranslate();
  const [data, setData] = useState({});
  const [res, setRes] = useState({});
  const [fdata, setFData] = useState({lang: []});
  const formEl = useRef(null);
  const token = getGlobalData('token');

  const CbLStyle = {paddingTop: '.5em', paddingRight: '.5em', display: 'inline-block', width: '7.7em'}
  const CbStyle = {mt:'.1em'}
  
  useEffect(() => {
    setData({})
    dataProvider.getOne('bwhTranslation', { id: 1 })
    .then(res  => {
      if(res.data)setData(res.data)
    })
  }, []);

  const storeLang = (id, val) => {
    const d = { ...fdata }
    const v = d.lang
    const idx = v.indexOf(id)
    if(val === true){
      if(idx === -1){
        v.push(id)
      }
    }
    else {
      if(idx > -1){
        v.splice(idx, 1)
      }
    }
    v.sort((a, b) => a - b)
    d.lang = v
    setFData(d)
  }

  const storeFile = async(files) => {
    const d = { ...fdata }
    const file = files[0]; // Access the first file
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const rawData = e.target.result; // Access the raw data here
        d.file = {
          fileName: file.name, 
          fileSize: file.size, 
          fileType: file.type, 
          rawFile: new Blob([rawData], {type:file.type})
        }
        setFData(d)
      }
      reader.onerror = (error) => {
          console.error("File reading error:", error);
      }
      reader.readAsArrayBuffer(file); 
    }
  }

  const handleAction = (action) => {
    dataProvider.update('bwhTranslation', { id: 1, data:{...fdata, ...{action: action}} })
      .then(res  => {
        if(res.data){
          setRes(res.data)
        }
      })
  }

  const doExport = (ev) => {
    formEl.current.submit();
  }

  const getCbLStyle = (el) => {
    const style = {...CbLStyle}
    if(data?.actLang?.includes(el.id)){
      style.fontWeight = 'bold'
    }
    return style
  }
  console.log(fdata)
  
  if(!data?.id)return
  return (         
    <Paper sx={{scroll:'auto', p: '2em'}} >
      <div>
        { data?.lang.map(el=>
          <div key={'chk'+el.id}>
            <span style={getCbLStyle(el)}>{el.name}</span>
            <Checkbox onChange={ev=>storeLang(el.id, ev.target.checked)} variant="outlined" size="small" sx={CbStyle} />
          </div>
        )}

        <div>
          <Button variant="contained" color="primary" value="-" onClick={()=>doExport()} sx={{mt:'1em'}}>{tr('bw.bwh.translation.exp_hostel_txt')}</Button>
        </div>
        <form method="post" action={apiPath+"v1/bwhTranslation"} ref={formEl} target="_blank">
          <input type="hidden" name="id" value={1} />
          <input type="hidden" name="token" value={token} />
          <input type="hidden" name="action" value='export' />
          <input type="hidden" name="lang" value={fdata.lang} />
        </form>
        
        <div style={{marginTop: '1em'}}>
          <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />}>
            {tr('bw.bwh.translation.select_file')}
            <VisuallyHiddenInput type="file" onChange={(ev) => storeFile(ev.target.files)} />
          </Button>
          { fdata?.file?.fileName ? 
            <span style={{marginLeft: '.5em'}}>{fdata?.file?.fileName} ({Math.round(fdata?.file?.fileSize/1000)} kb)</span>
            :
            <span style={{marginLeft: '.5em'}}>{tr('bw.bwh.translation.no_file')}</span>
          }
        </div>
        
        <div>
          <Button variant="contained" color="primary" value="-" onClick={()=>handleAction('import')} sx={{mt:'1em'}}>{tr('bw.bwh.translation.imp_txt')}</Button>
        </div>
        { isHauptadmin() && <div>
          <Button variant="contained" color="primary" value="-" onClick={()=>handleAction('check')} sx={{mt:'1em'}}>{tr('bw.bwh.translation.check')}</Button>
        </div>}
      </div>
      <div>
        <Ansi>{res?.log}</Ansi>
      </div>
      
    </Paper>
  )
}
export default BwhTranslation;
